import { NullableString } from "./Types";
import moment, { Moment } from "moment-timezone";

export class Helpers {
  static convertToEST(date: Date): Moment {
    return moment.tz(date, "America/New_York");
  }

  static sortDate(a: NullableString, b: NullableString): number {
    if (a === null) {
      return -1;
    }
    if (b === null) {
      return 1;
    }
    return Date.parse(a) - Date.parse(b);
  }
}
